import React, { ReactElement } from 'react';
import { NotFoundPage } from 'slovlex-idsk-react-components';
import SecuredPageComponent from './component/SecuredPageComponent';
import { useUserContext } from '../../context/UserContext';
import UserRoleEnum from '../../model/currentuser/UserRole';
import { ForbiddenPage } from '../../page';
import { useClientStatusContext } from '../../context/ClientStatusContext';

interface Props {
  children: ReactElement;
  allowForRoles?: Array<UserRoleEnum>;
  requestStatus?: number;
  additionalCheck?: boolean;
}

const SecuredPage = ({
  children, allowForRoles, requestStatus, additionalCheck,
}: Props): ReactElement => {
  const { pouzivatel } = useUserContext();

  const {
    status,
    clearStatus,
  } = useClientStatusContext();

  if (status?.responseCode === 403) {
    return <ForbiddenPage onClear={clearStatus} />;
  }

  if (requestStatus === 404) {
    return <NotFoundPage />;
  }

  return (
    <SecuredPageComponent
      pouzivatel={pouzivatel}
      allowForRoles={allowForRoles}
      additionalCheck={additionalCheck}
    >
      {children}
    </SecuredPageComponent>
  );
};

export default SecuredPage;
